export default {
    title: "",
    unavailable: "Dieses Produkt ist nicht mehr erhältlich."
}